import React, { Component } from 'react';
import { CardMedia } from '@material-ui/core';
import AuthorItem from '../PageHome/EpisodeGrid/CreditsItems/authors';
import CitationItem from '../PageHome/EpisodeGrid/CreditsItems/citation';
import { ArtEmoji, CitationEmoji, MusicEmoji, AuthorEmoji, ContactsEmoji, PersonEmoji, MusicItemEmoji } from '../Utils/Emojis/index';
import imgGridContainerBottom from '../../assets/img/Paper/papelBaixo.webp';
import { readPublicContact, readPublicContacts, readPublicEpisode } from '../../api/public';
import { readPublicMetadata } from '../../api/publicMetadata';
import SpotifyCard from './SpotifyCard/SpotifyCard';
import './EpisodePage.css';
import DisqusComments from './CommentSection/CommentSection';

export default class EpisodePage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            epi: {},
            isLoading: false,
            isLoadingContacts: false,
            isLoadingContactInfo: false,
            isLoadingMetadata: false,
            error: null,
            contacts: [],
            contactInfo: {
                email: '',
            },
            metadata: {
                disqus: {
                    shortName: '',
                },
            },
        }
    }

    parseEpisodeId = (rawId) => {
        const episodeId = Number(rawId);

        if (!Number.isInteger(episodeId) || episodeId <= 0) {
            return null;
        }

        return episodeId;
    }

    normalizeReference = (reference) => {
        if (!reference) {
            return { name: '' };
        }

        if (typeof reference === 'string') {
            return { name: reference };
        }

        const contacts = (reference.links || []).reduce((accumulator, link) => {
            if (link && link.label && link.url) {
                accumulator[link.label] = link.url;
            }

            return accumulator;
        }, {});

        return {
            name: reference.name,
            contacts,
        };
    }

    loadEpisode = (episodeId) => {
        this.setState({ isLoading: true });

        readPublicEpisode(episodeId)
            .then(epi => {
                this.setState({ epi, isLoading: false }, () => {
                    document.title = this.state.epi.title;
                });
            })
            .catch(error => this.setState({ error, isLoading: false }));
    }

    loadContacts = () => {
        this.setState({ isLoadingContacts: true });

        readPublicContacts()
            .then(data => this.setState({ contacts: data.authors || [], isLoadingContacts: false }))
            .catch(error => this.setState({ error, isLoadingContacts: false }));
    }

    loadContactInfo = () => {
        this.setState({ isLoadingContactInfo: true });

        readPublicContact()
            .then(contactInfo => this.setState({ contactInfo, isLoadingContactInfo: false }))
            .catch(error => this.setState({ error, isLoadingContactInfo: false }));
    }

    loadMetadata = () => {
        this.setState({ isLoadingMetadata: true });

        readPublicMetadata()
            .then((metadata) => this.setState({ metadata, isLoadingMetadata: false }))
            .catch(error => this.setState({ error, isLoadingMetadata: false }));
    }

    componentDidMount() {
        const episodeId = this.parseEpisodeId(this.props.match.params.id);

        if (!episodeId) {
            this.setState({
                error: new Error('invalid episode id'),
            });
            return;
        }

        this.loadEpisode(episodeId);
        this.loadContacts();
        this.loadContactInfo();
        this.loadMetadata();

    }

    render() {
        const { epi, isLoading, error, isLoadingContacts, isLoadingContactInfo, isLoadingMetadata, contacts, contactInfo, metadata } = this.state;

        if (error) { return <p>{error.message}</p> }
        if (isLoading || isLoadingContacts || isLoadingContactInfo || isLoadingMetadata || !epi.episodeId) { return <p>Loading ...</p> }

        let header =
            <div className="gridContainerTopUnder">
                <div className="gridContainerTopSpotify"></div>
            </div>

        let episodeTitle = <div className="title">{epi.title}</div>

        let embedCard;
        if (epi.spotifyEmbedUrl || epi.spotifyId) {
            embedCard = <SpotifyCard spotifyEmbedUrl={epi.spotifyEmbedUrl} spotifyId={epi.spotifyId} title={epi.title} />
        } else if (epi.youtubeEmbedUrl) {
            embedCard =
                <CardMedia component="iframe"
                    className="youtubeCard"
                    src={epi.youtubeEmbedUrl}
                    alt={epi.title}
                    allowFullScreen
                    frameBorder={0}
                />
        }

        let downloadLink;
        if (epi.downloadUrl != null) {
            downloadLink =
                <div className="guests-summary container-summary">
                    <h3><a href={epi.downloadUrl} download={epi.title}>Download</a></h3>
                </div>
        }

        let description = <div className="text-summary container-summary">{epi.summary}</div>

        let links =
            <div className="container-summary">
                <h3><ContactsEmoji />Contato<ContactsEmoji /></h3>
                <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
            </div>

        let citations;
        if (epi.citations != null) {
            citations =
                <div className="container-summary">
                    <h3><CitationEmoji />Citações<CitationEmoji /></h3>
                    {epi.citations.map((citation, i) => <CitationItem key={i} cite={{ name: citation }} />)}
                </div>
        }

        let guests;
        if (epi.guests != null) {
            guests =
                <div className="creditsBlock">
                    <h3><PersonEmoji />Convidados<PersonEmoji /></h3>
                    {epi.guests.map((guest, i) => {
                        return <CitationItem key={i} cite={this.normalizeReference(guest)} />
                    })}
                </div>
        }

        let coverArtist;
        if (epi.coverCredits != null) {
            coverArtist =
                <div className="creditsBlock">
                    <h3><ArtEmoji />Arte<ArtEmoji /></h3>
                    {epi.coverCredits.map((c, i) => {
                        if (c.member) {
                            const author = contacts.find((candidate) => candidate.name === c.name);
                            return <CitationItem key={i} cite={author || { name: c.name }} />
                        }

                        return <CitationItem key={i} cite={{ name: c.name }} />
                    })}
                </div>
        }

        let musicCredits;
        if (epi.musicCredits != null) {
            musicCredits =
                <div className="creditsBlock">
                    <h3><MusicEmoji />Músicas<MusicEmoji /></h3>
                    {epi.musicCredits.map((m, i) => <CitationItem key={i} cite={this.normalizeReference(m)} mark={MusicItemEmoji} />)}
                </div>
        }

        let authors;
        if (contacts.length > 0 && epi.authors != null) {
            authors =
                <div className="creditsBlock">
                    <h3><AuthorEmoji /> Autores <AuthorEmoji /></h3>
                    {contacts.map((author, index) => <AuthorItem key={index} author={author} validAuthors={epi.authors.map((item) => item.name)} />)}
                </div>
        }

        let footer = <div className="gridContainerBottom" style={{ backgroundImage: `url(${imgGridContainerBottom})`, marginTop: "-1px" }}></div>

        return (
            <div className="episodePage ContentPage">
                {header}
                {episodeTitle}
                {embedCard}
                <div className="summary fontSummary">
                    {downloadLink}
                    {description}
                    {/* <div className="description-summary container-summary" dangerouslySetInnerHTML={{ __html: epi.description }}/> */}
                    <DisqusComments post={{ id: epi.episodeId, title: epi.title }} shortName={metadata.disqus.shortName} />
                    {links}
                    {citations}
                    <div className='credits'>
                        {guests}
                        {coverArtist}
                        {musicCredits}
                        {authors}
                    </div>
                </div>
                {footer}
            </div>
        );
    }
}
